import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import { FiCalendar, FiMapPin } from "react-icons/fi";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDocs(query(collection(db, "events"), orderBy("eventDate", "asc")));
        setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) {}
      setLoading(false);
    };
    fetch();
  }, []);

  return (
    <div className="bg-white min-h-screen" style={{ fontFamily: "Montserrat, sans-serif" }}>
      {/* HERO */}
      <section className="bg-[#f7d8e8]">
        <div className="max-w-[1400px] mx-auto h-[165px] flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-[28px] md:text-[32px] font-extrabold tracking-wide uppercase leading-none">Events</h1>
          <div className="mt-2 flex items-center gap-3 text-[13px] md:text-[14px]">
            <Link to="/" className="text-[#b8b8b8] hover:text-black transition">Home</Link>
            <span className="text-[#b8b8b8]">/</span>
            <span className="text-black">Events</span>
          </div>
        </div>
      </section>

      <div className="max-w-[1240px] mx-auto px-6 md:px-10 lg:px-12 py-12">
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-4 border-[#e84fa5] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : events.length === 0 ? (
          <div className="text-center py-20 text-gray-400">
            <FiCalendar size={48} className="mx-auto mb-4 opacity-30" />
            <p className="text-lg">No upcoming events.</p>
            <p className="text-sm mt-2">Check back soon!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {events.map((event) => (
              <Link key={event.id} to={`/event/${event.id}`} className="group">
                <div className="bg-white rounded-xl border border-gray-100 overflow-hidden hover:shadow-lg transition h-full flex flex-col">
                  <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                    {event.image ? (
                      <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-300" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-gray-300"><FiCalendar size={40} /></div>
                    )}
                  </div>
                  <div className="p-5 flex-1 flex flex-col">
                    {event.eventDate && (
                      <div className="flex items-center gap-2 text-[11px] text-[#e84fa5] font-bold uppercase mb-2">
                        <FiCalendar size={12} />
                        {new Date(event.eventDate).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })}
                      </div>
                    )}
                    <h3 className="text-[14px] font-extrabold text-black leading-tight mb-2 line-clamp-2 group-hover:text-[#e84fa5] transition">
                      {event.title}
                    </h3>
                    {event.venue && (
                      <p className="text-[11px] text-gray-500 flex items-center gap-1.5 mt-auto">
                        <FiMapPin size={11} /> {event.venue}
                      </p>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;
